module.exports = __webpack_public_path__ + "static/realitio-873e589a4c9285bb40335da109d973b4.png";